import React from "react";
import { Text, TextProps } from "@chakra-ui/react";

const TextRequired: React.FC<TextProps> = ({ children, ...props }) => {
  return (
    <Text as="span" color="red" {...props}>
      {children}
    </Text>
  );
};

export default TextRequired;
